module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"return":"Go back","input":"Email","action":"Get code","already-have":"I already have code"},"pt-BR":{"return":"Voltar","input":"E-mail","action":"Obter código","already-have":"Já tenho um código"}}')
  delete Component.options._Ctor
}
